
import React, { useEffect, useState } from "react";
import { getEmployeeDocuments } from "../../api/employeeApi";
import { useNavigate } from "react-router-dom";
import { FILE_BASE_URL } from "../../config";

const UploadedDocuments = () => {
  const [docs, setDocs] = useState([]);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const navigate = useNavigate();
  const employeeCode = sessionStorage.getItem("username");

  useEffect(() => {
    if (employeeCode) {
      getEmployeeDocuments(employeeCode)
        .then((res) => {
          setDocs(Array.isArray(res) ? res : []);
        })
        .catch((err) => {
          console.error("Error fetching docs:", err);
          setDocs([]);
        });
    }
  }, [employeeCode]);

  return (
    <div className="p-4" style={{ maxWidth: "900px", margin: "auto" }}>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="allowance-heading mb-0">My Uploaded Documents</h4>
        <button
          className="btn btn-secondary btn-sm"
          onClick={() => navigate(-1)}
        >
          ⬅ Back
        </button>
      </div>

      {docs.length === 0 ? (
        <p>No documents uploaded yet.</p>
      ) : (
        <>
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Financial Year</th>
                <th>Section</th>
                <th>Purpose</th>
                <th>Amount</th>
                <th>Document</th>
              </tr>
            </thead>
            <tbody>
              {docs.map((doc) => (
                <tr key={doc.id}>
                  <td>{doc.financialYear}</td>
                  <td>{doc.sectionCode}</td>
                  <td>{doc.purpose}</td>
                  <td>{doc.amount}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => setSelectedDoc(doc)}
                    >
                      Preview
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

        {selectedDoc && (
          <div className="mt-4">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5 className="mb-0">Preview: {selectedDoc.purpose}</h5>
              <button
                className="btn btn-sm btn-danger"
                onClick={() => setSelectedDoc(null)}
              >
                Close
              </button>
            </div>

            {selectedDoc.documentType?.toLowerCase().includes("pdf") ? (
              <iframe
                src={
                  selectedDoc.documentPath.startsWith("http")
                    ? selectedDoc.documentPath
                    : `${FILE_BASE_URL}/${selectedDoc.documentPath.replace(/\\/g, "/")}`
                }
                title="PDF Preview"
                width="100%"
                height="500px"
              />
            ) : (
              <img
                src={
                  selectedDoc.documentPath.startsWith("http")
                    ? selectedDoc.documentPath
                    : `${FILE_BASE_URL}/${selectedDoc.documentPath.replace(/\\/g, "/")}`
                }
                alt={selectedDoc.purpose}
                style={{
                  maxHeight: "500px",
                  maxWidth: "100%",
                  border: "1px solid #ccc",
                  objectFit: "contain",
                }}
              />
            )}
          </div>
        )}
        </>
      )}
    </div>
  );
};

export default UploadedDocuments;
